mtl.alloy.factory['collapse'] = (function($) {
	'use strict';

	var $collapsed = $collapsed ? $collapsed : [];

	/**
	 * Controller for the layout header element.
	 */
	return function(element, options) {

		var $element = $(element);

		var $collapseLink = $element.find('.collapse');

		$collapseLink.each(function(){
			var $collapsible = $('.collapsible', $(this).parent());
			if($.inArray($collapsible.attr('id'), $collapsed) >= 0)
			{
				$(this).addClass('is-collapsed');
				$collapsible.hide();
			}
		});

		$collapseLink.on('click tap', function(){

			var collapse = !$collapseLink.hasClass('is-collapsed');

			$collapseLink.toggleClass('is-collapsed', collapse);

			var collapsible = $element.find('.collapsible');
			var id = collapsible.attr('id');

			if (collapse) {
				collapsible.stop().slideUp();
				$collapsed.push(id);
			} else {
				collapsible.stop().slideDown();
				$collapsed = $.grep($collapsed, function(value) {
				  return value != id;
				});
			}
		});

	};

}($));
